var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_4336)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 14.4833V6.66667H25.5167L20 1.15L14.4834 6.66667H6.66669V14.4833L1.15002 20L6.66669 25.5167V33.3333H14.4834L20 38.85L25.5167 33.3333H33.3334V25.5167L38.85 20L33.3334 14.4833ZM20 30C14.4834 30 10 25.5167 10 20C10 14.4833 14.4834 10 20 10C25.5167 10 30 14.4833 30 20C30 25.5167 25.5167 30 20 30ZM20 13.3333C16.3167 13.3333 13.3334 16.3167 13.3334 20C13.3334 23.6833 16.3167 26.6667 20 26.6667C23.6834 26.6667 26.6667 23.6833 26.6667 20C26.6667 16.3167 23.6834 13.3333 20 13.3333Z",
    fill: "#04B7B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_4336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsDefault);
export default __webpack_public_path__ + "static/media/Settings-Default.59dee8ed2a118fac3474b92e2ba96120.svg";
export { ForwardRef as ReactComponent };